import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BannerSection from './Partials/BannerSection';
import LatestNewsSection from './Partials/LatestNewsSection';
import OverviewSection from './Partials/OverviewSection';
import './index.css';
import PrincipalSpeakSection from './Partials/PrincipalSpeakSection';
import LogoSection from './Partials/LogoSection';
import FacultyMembers from './Partials/FacultyMembers';
import FacilitiesSection from './Partials/FacilitiesSection';
import StudentLifeSection from './Partials/StudentLifeSection';
import FindOutMoreSection from './Partials/FindOutMoreSection';
import NewsEventsSection from './Partials/NewsEventsSection';
import ProgramsSection from './Partials/ProgramsSection';
import StickyNavSection from './Partials/StickyNavSection';

const CollegePage = () => {
  const location = useLocation();

  const scrollToSection = (targetId) => {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const yOffset = -100;
      const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        scrollToSection(location.state.scrollTo);
      }, 200);
    }

    else if (window.location.hash) {
      const sectionId = window.location.hash.substring(1);
      setTimeout(() => {
        scrollToSection(sectionId);
      }, 200);
    }
  }, [location]);


  return (
    <div className="college-page">
        <BannerSection />
        <LatestNewsSection />
        <StickyNavSection/>
        <OverviewSection />
        <ProgramsSection />
        <PrincipalSpeakSection />
        <LogoSection />
        <FacultyMembers />
        <FacilitiesSection />
        <StudentLifeSection />
        <NewsEventsSection />
        <FindOutMoreSection />
    </div>
  );
};

export default CollegePage;